// extracted by mini-css-extract-plugin
export default {"cartIconWrapper":"CartIcon_cartIconWrapper__1m6jZ","itemCount":"CartIcon_itemCount__fygq5","itemCountFooter":"CartIcon_itemCountFooter__v89K1"};